import React, { useEffect, useState } from "react";
import { splitArrayToChunks } from "utility/helpers";
import { Col, Input } from "reactstrap";
import _ from "lodash";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { fetchAllAgencies } from "services/services.projects";
import styled from "styled-components";
import AgencyContainer from "./AgencyContainer";
import { getFormattedAgencies } from "./utility";

const AgencyParentContainer = styled.div`
  justify-content: center;
  grid-template-columns: 400px 400px 400px;
  display: grid;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 250px 250px;
  }

  @media (max-width: 575px) {
    grid-template-columns: 200px;
  }

  @media (min-width: 768.98px) and (max-width: 1200px) {
    grid-template-columns: 280px 280px;
  }
`;

const MainContainer = styled.div`
  margin: 0;
  padding: 0;

  @media (max-width: 575.98px) {
    h1 {
      font-size: 1.25rem;
    }
  }

  @media (max-width: 340px) {
    .program-container {
      .pl-0.col {
        display: none;
      }

      width: auto !important;

      img {
        height: 60px;
      }
    }
  }

  // Large devices (desktops, less than 1200px)
  @media (max-width: 1199.98px) {
    .program-container {
      width: 300px;
    }
  }
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  margin-top: 50px;
  margin-bottom: 44px;
`;

const SearchbarSection = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 24px;
`;

const SearchbarWrapper = styled.div`
  width: 40%;
  position: relative;

  input {
    background: white;
    box-shadow: none;
    border-radius: 4px;

    &:focus {
      box-shadow: none;
      border-color: ${({ theme }) => theme.colors.systemBlue};
    }
  }
`;

const AgencyWrapper = styled(Col)`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const AgencyList = () => {
  const dateRange = useSelector((state) => state.dateRange);
  const [initialData, setInitialData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { dateFrom } = dateRange || {};

  const fetchData = () => {
    try {
      setIsLoading(true);

      fetchAllAgencies({
        callback: (projects) => {
          if (projects?.length === 1) navigate(`/projects/${projects[0]?.id}`);

          if (projects?.length !== 0) {
            const result = getFormattedAgencies(projects);
            setFilteredData(result);
            setInitialData(result);
          }
          setIsLoading(false);
        },
        dateRange,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  const handleSearch = _.debounce((evt) => {
    const term = evt.target.value;

    if (term?.length === 0) {
      setFilteredData(initialData);

      return;
    }

    const newArray = initialData.flat();
    const result = [];

    newArray.forEach((agency) => {
      if (
        agency?.acronym?.toLowerCase()?.includes(term?.toLowerCase()) ||
        agency?.label?.toLowerCase()?.includes(term?.toLowerCase())
      ) {
        result.push(agency);
      }
    });

    if (result?.length !== 0) {
      if (result?.length >= 3) {
        const newData = splitArrayToChunks(result, 3);
        setFilteredData(newData);

        return;
      }

      setFilteredData(result);

      return;
    }

    setFilteredData([]);
  }, 1500);

  const renderAgencies = (data) => {
    const agency = (datum) => (
      <AgencyWrapper key={datum?.id}>
        <AgencyContainer
          key={datum?.id}
          {...datum}
        />
      </AgencyWrapper>
    );

    if (Array.isArray(data)) {
      return data.map((d) => agency(d));
    }

    return agency(data);
  };

  useEffect(() => {
    fetchData();
  }, [dateFrom]);

  return (
    <MainContainer>
      <HeaderSection>
        <h1>{"Projects and Programs (Select an Agency)"}</h1>
      </HeaderSection>

      <SearchbarSection>
        <SearchbarWrapper>
          <Input
            placeholder="Search"
            onChange={handleSearch}
            disabled={isLoading}
          />
        </SearchbarWrapper>
      </SearchbarSection>

      <AgencyParentContainer>
        {filteredData?.length !== 0 &&
          filteredData?.map((datum) => {
            return (
              <Col
                key={datum?.id}
                xs="auto"
              >
                {renderAgencies(datum)}
              </Col>
            );
          })}
      </AgencyParentContainer>
    </MainContainer>
  );
};

export default AgencyList;
